import React from "react";

function Canvas_Text_Color() {
  return (
    <div>
      <h1>Canvas_Text_Color Component</h1>
      <p>This is the Canvas Text Color tutorial page content.</p>
    </div>
  );
}

export default Canvas_Text_Color;
